import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import * as actions from './actions';
import { IndexType } from '@fnModels/algolia/algolia';
import { getIndex } from '@state/utils/helper';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';

export type CondoCorporationManagementsSearchStateModel =
	AlgoliaBaseState<unknown>;

@State<CondoCorporationManagementsSearchStateModel>({
	name: 'condoCorporationsManagementSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class CondoCorporationManagementsSearchState extends AlgoliaSearchState<CondoCorporationManagementsSearchStateModel> {
	protected indexName = getIndex(IndexType.CONDO_CORPORATIONS_MANAGEMENT);

	@Selector([CondoCorporationManagementsSearchState])
	static getList(
		state: CondoCorporationManagementsSearchStateModel,
	): unknown[] {
		return state?.items;
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<CondoCorporationManagementsSearchStateModel>,
		{ searchTerm }: actions.Search,
	): Promise<void> {
		await this.algoliaSearchHandler(ctx, searchTerm);
	}
}
